import OpenDetails, { Props } from './OpenDetails';

export default OpenDetails;
export { type Props };